<template>
    <!-- 了解索道云-新闻动态页 -->
  <div>
    <Header></Header>
    <div>
        <!-- banner -->
        <div class="banner">
          <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/channel_detail/4' }">了解索道云</el-breadcrumb-item>
              <el-breadcrumb-item>新闻动态</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <!-- main -->
        <div class="main">
          <!-- 列表 -->
          <div class="container" v-for="(item,index) in newsList" :key="index">
            <el-row class="box">
              <el-col :span="4">
                <img class="picture" :src="item.image" alt="">
              </el-col>
              <el-col :span="16">
                <div class="content" @click="enterDetail(index)">
                  <div class="con_title">{{item.title}}</div>
                  <div class="con_content">{{item.summary}}</div>
                </div>
                <!-- <mavon-editor :value="item.content"
                :subfield = "false"
                :defaultOpen = "'preview'"
                :toolbarsFlag = "false"
                :editable="false"
                :scrollStyle="true"
                :ishljs = "true"/> -->
              </el-col>
              <el-col :span="4" align="right">
                <div class="date" v-text="item.publish.substr(5,5).replace('-','.')"></div>
                <div class="dash">一</div>
                <div class="year" v-text="item.publish.substr(0,4)"></div>
              </el-col>
            </el-row>
          </div>
          <!-- 分页 -->
          <el-pagination
            align="center"
            @current-change="handleCurrentChange"
            :current-page.sync="nowPage"
            :page-size="pageSize"
            background
            layout="prev, pager, next"
            :total="newsTotal">
          </el-pagination>
        </div>
      </div>
      <Footer></Footer>
  </div>
</template>
<script>
    import { queryNewsList } from '@/api/channel/ljsdy.js'
    import Header from '../../../components/common/header.vue'
    import Footer from '../../../components/common/footer.vue'
    export default {
        components: {
            Header,
            Footer,
        },
        data() {
            return {
                nowPage: 1, //当前页
                pageSize: 5, //每页显示个数
                newsList: [],
                newsTotal: 0,
            }
        },
        created() {
            this.queryNews();
        },
        methods: {
            //查询新闻列表
            queryNews() {
                let param = {
                    nowPage: this.nowPage,
                    pageSize: this.pageSize,
                    status: "Y",
                    title: ""
                }
                queryNewsList(param).then(res => {
                    // console.log(res.data);
                    this.newsList = res.data.list;
                    this.newsTotal = res.data.total;
                })
            },
            //点击进入详情页
            enterDetail(index) {
                this.$router.push({
                    path: '/ljsdy/newsDetails',
                    query: {
                        index
                    }
                });
            },
            //当前页改变触发
            handleCurrentChange(val) {
                this.nowPage = val;
                this.queryNews();
            },
        }
    }
</script>

<style lang="scss" scoped="scoped">
    /* banner */
    
    .banner {
        display: flex;
        align-items: center;
        width: 100%;
        height: 54px;
        margin-top: 80px;
        background: url(../../../assets/channel/ljsdy/news_01.png) no-repeat center center;
        background-size: 100% 100%;
    }
    
    .banner div {
        width: 1100px;
        margin: auto;
    }
    /* main */
    
    .main {
        width: 1100px;
        margin: auto;
        margin-bottom: 100px;
    }
    
    .container {
        margin: 30px 0;
    }
    
    .box {
        /* height: 220px; */
        padding: 54px 0;
        border-bottom: 1px solid #E5E5E5;
    }
    
    .picture {
        width: 100%;
        height: 112px;
        object-fit: cover;
    }
    
    .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 112px;
        margin: 0 30px;
    }
    
    .content:hover {
        cursor: pointer;
        .con_title {
            color: #537EEE;
        }
    }
    
    .con_title {
        margin-bottom: 10px;
        font-size: 17px;
        color: #333;
    }
    
    .con_content {
        font-size: 12px;
        color: #6C6C6C;
    }
    
    .date {
        font-size: 30px;
        color: #515151;
    }
    
    .dash {
        font-size: 16px;
        font-weight: 700;
        color: rgba(87, 131, 238, 1);
    }
    
    .year {
        font-size: 12px;
        color: #959595;
    }
    
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #537EEE;
    }
</style>